import theme from '@ifca-root/react-component/src/assets/theme'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { MoreVert } from '@material-ui/icons'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { useGetCreditorAccountQuery } from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import React, { useMemo, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import {
  PayeeEFTDetailsDialog,
  EFTDetailFormData,
} from './PayeeEFTDetailsDialog'
import { beneBankSetupOptions } from './DummyDataEFTDetails'

export const PayeeDetailsForm = (props: any) => {
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { BankEFTID, CreditorAccountID }: any = useParams()

  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [eftDetails, setEftDetails] = useState<EFTDetailFormData[]>([])
  const [openEFTDialog, setOpenEFTDialog] = useState<boolean>(false)
  const [editIndex, setEditIndex] = useState<number | null>(null)
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()

  const {
    loading: CreditorAccountLoading,
    data: { getCreditorAccount } = { getCreditorAccount: [] },
  } = useGetCreditorAccountQuery({
    fetchPolicy: 'network-only',
    variables: { CreditorAccountID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
    },
  })

  const creditorData = useMemo(() => {
    if (getCreditorAccount?.length > 0) {
      return (
        getCreditorAccount.find(
          el => el?.CreditorAccountID === CreditorAccountID
        ) ?? getCreditorAccount[0]
      )
    }
    return null
  }, [getCreditorAccount, CreditorAccountID])

  const handleAddEFTDetail = () => {
    setEditIndex(null)
    setOpenEFTDialog(true)
  }

  const handleEditEFTDetail = (index: number) => {
    setEditIndex(index)
    setOpenEFTDialog(true)
  }

  const handleDeleteEFTDetail = (index: number) => {
    setEftDetails(prev => prev.filter((_, i) => i !== index))
  }

  const handleConfirmEFTDetail = (data: EFTDetailFormData) => {
    if (editIndex !== null) {
      setEftDetails(prev =>
        prev.map((item, i) => (i === editIndex ? data : item))
      )
    } else {
      setEftDetails(prev => [...prev, data])
    }
    setOpenEFTDialog(false)
    setEditIndex(null)
  }

  const getBeneBankLabel = (value: string): string => {
    return beneBankSetupOptions.find(b => b.value === value)?.label ?? value
  }

  const handleSave = () => {
    history.push(`/bank-eft/${BankEFTID}/payee-details`)
  }

  return (
    <>
      {CreditorAccountLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => history.push(`/bank-eft/${BankEFTID}/payee-details`)}
        smTitle={'AccountX'}
        title={user?.accountName}
        routeSegments={[
          { name: 'EFT Settings' },
          { name: 'Payee Details' },
          { name: creditorData?.CompanyName ?? 'Form', current: true },
        ]}
      />

      <ContentWrapper footer>
        <CardContents section={{ header: { title: 'Supplier Details' } }}>
          <TextField
            label="Company Registration No."
            value={creditorData?.CompanyRegNo ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
            required
          />
          <TextField
            label="Company Name"
            value={creditorData?.CompanyName ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
            required
          />
          <TextField
            label="Phone No."
            value={creditorData?.ContactNo ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
            required
          />
          <TextField
            label="Email Address"
            value={creditorData?.Email ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
          />
        </CardContents>

        <CardContents section={{ header: { title: 'Address Info' } }}>
          <TextField
            label="Address"
            value={creditorData?.Address?.address ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
            required
          />
          <TextField
            label="Country"
            value={creditorData?.Address?.country ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="State"
            value={creditorData?.Address?.state ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="City"
            value={creditorData?.Address?.city ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
            className="left"
          />
          <TextField
            label="Postcode"
            value={creditorData?.Address?.postCode ?? ''}
            fullWidth
            margin="dense"
            disabled
            InputLabelProps={{ shrink: true }}
            className="right"
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: `EFT details (${eftDetails?.length})`,
              onClickAction: handleAddEFTDetail,
              icon: (
                <AddIcon
                  htmlColor="white"
                  fontSize="small"
                  style={{
                    width: '20px',
                    height: '20px',
                    margin: '0',
                    background: theme.palette.primary.main,
                    borderRadius: '3px',
                    color: 'rgba(224,234,254,100)',
                    marginTop: '10px',
                    marginRight: '10px',
                  }}
                />
              ),
            },
          }}
        >
          {eftDetails?.length === 0 ? (
            <div
              style={{
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <EmptyList
                title="No Record Found"
                subtitle="Add New Record now."
              />
            </div>
          ) : (
            eftDetails.map((el, index) => (
              <List key={index} style={{ width: '100%', paddingBottom: '0px' }}>
                <ListItem style={{ marginLeft: '-5px', marginTop: '-15px' }}>
                  <ListItemText
                    primary={
                      <span className="xsTitle">
                        {getBeneBankLabel(el.beneBankName)}
                      </span>
                    }
                    secondary={
                      <span className="desc">
                        {el.beneficiaryBankAccount}
                        {el.ibgBankCode ? ` | IBG: ${el.ibgBankCode}` : ''}
                      </span>
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      aria-label="more"
                      aria-controls="eft-menu"
                      aria-haspopup="true"
                      onClick={e => handleClick(e, String(index), index, el)}
                    >
                      <MoreVert />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            ))
          )}
        </CardContents>
      </ContentWrapper>

      <Menu
        id="eft-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleEditEFTDetail(menu?.index)
          }}
        >
          <span className="mdDesc">Edit</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDeleteEFTDetail(menu?.index)
          }}
        >
          <span className="mdDesc">Delete</span>
        </MenuItem>
      </Menu>

      <Footer
        options={[
          {
            name: 'Save',
            color: 'primary',
            onClick: handleSave,
          },
        ]}
      />

      {openEFTDialog && (
        <PayeeEFTDetailsDialog
          key={editIndex !== null ? `edit-${editIndex}` : 'new'}
          open={openEFTDialog}
          onClose={() => {
            setOpenEFTDialog(false)
            setEditIndex(null)
          }}
          onConfirm={handleConfirmEFTDetail}
          editData={editIndex !== null ? eftDetails[editIndex] : undefined}
        />
      )}

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
